import type { ShouldRevalidateFunctionArgs } from 'react-router';

/**
 * Prevents loader revalidation for in-place mutations when the navigation stays
 * on the same pathname (cart, wishlist, newsletter, OpenTable booking, etc.).
 */
export function shouldSkipRevalidationForCartOrWishlistAndNewsletterActions({
    currentUrl,
    nextUrl,
    formAction,
}: Pick<ShouldRevalidateFunctionArgs, 'currentUrl' | 'nextUrl' | 'formAction'>): boolean {
    if (!formAction) return false;
    if (currentUrl.pathname !== nextUrl.pathname) return false;

    // Use includes() so absolute formAction URLs (host + path) still match.
    return (
        formAction.includes('/action/cart-') ||
        formAction.includes('/action/crm-') ||
        formAction.includes('/action/promo-code-') ||
        formAction.includes('/action/basket-cart-accessories') ||
        formAction.includes('/action/wishlist-') ||
        formAction.includes('/action/loyalty-enrollment') ||
        formAction.includes('/action/newsletter') ||
        formAction.includes('/action/dismiss-country-suggestion') ||
        formAction.includes('/action/remember-country-geolocation') ||
        formAction.includes('/resource/opentable/')
    );
}
